import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["viewPathCard", "viewTitle", "viewPathCardBody", "previewCard", "previewTitle", "9999"]

  connect() {
    this.controllerName = `users--works--permissions--paths--show`
    this.doViewHtml()
  }

  doViewHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="viewPathCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 py-3" style="font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Nenhuma URL Selecionada</h6>
                  </div>
                  <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="viewPathCardBody"></div>
                </div>`

    this.getControllerByIdentifier("users--works--permissions--paths--dashboard").viewTarget.innerHTML = html
  }

  editPath() {
    if (this.application.permissions[this.permission].can_update) {
      this.getControllerByIdentifier("users--works--permissions--paths--save").current_path = this.current_path
      this.getControllerByIdentifier("users--works--permissions--paths--save").actionMode = "edit"
      this.getControllerByIdentifier("users--works--permissions--paths--save").doFormHtml()
    } else {
      this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(`danger`, `Ação não permitida`, 5000)
    }
  }

  deletePath() {
    this.send_data = { current_user: {}, path: {} }

    this.actionMode = `delete`
    this.send_data.path.id = this.current_path.id
    this.send_data.path.active = false
    this.send_data.path.status = `inactive`

    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = `user_permissions_paths`

    var r = confirm(`Tem certeza que deseja inativar a URL /${this.current_path.path}?`)
    if (r) {
      this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()
      this.getControllerByIdentifier("users--works--permissions--paths--save").send_data = this.send_data
      this.getControllerByIdentifier("users--works--permissions--paths--save").actionMode = `delete`
      this.getControllerByIdentifier("users--works--permissions--paths--save").requestSave()
    }
  }

  doPathHtml() {
    this.getControllerByIdentifier(`users--works--permissions--paths--save`).stopRefreshing()
    var spaceRow = `<td colspan="10" style="height:2rem;padding-top:1rem;padding-bottom:1rem;" scope="col"></td>`

    if (this.application.permissions[this.permission].can_delete) {
      var deleteBtnHtml = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-${this.controllerName}-target="deletePathBtn" data-action="click->${this.controllerName}#deletePath" type="button">
                            <span class="material-icons f-1p25">delete</span>
                          </button>
                          <span class="mc-tooltiptext">Apagar URL</span>`
    } else {
      var deleteBtnHtml = ``
    }

    if (this.application.permissions[this.permission].can_update) {
      var editBtnHtml = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-${this.controllerName}-target="editPathBtn" data-action="click->${this.controllerName}#editPath" type="button">
                            <span class="material-icons f-1p25">edit</span>
                          </button>
                          <span class="mc-tooltiptext">Editar URL</span>`
    } else {
      var editBtnHtml = ``
    }

    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="previewCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4" style="padding:1rem;font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="previewTitle"></h6>
                    <div class="card-actions ml-auto py-0 mc-tooltip">
                      ${editBtnHtml}
                    </div>
                    <div class="card-actions py-0 mc-tooltip">
                      ${deleteBtnHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;" data-${this.controllerName}-target="previewCardBody">
                    <div class="row my-1">
                      <div class="col-12">
                        <table class="table table-sm table-borderless" style="font-size:80%;">
                          <tbody>
                            <tr>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-20 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-20 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-20 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-20 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-20 align-middle"></td>
                            </tr>
                            <tr>
                              <th colspan="1" class="f-065 align-middle px-0">
                                <strong>Enum</strong>
                              </th>
                              <td colspan="4" class="f-065 align-middle px-0 text-left">
                                <span class="mb-0 f-065 mc-tooltip grab">
                                  <span data-controller="app--helpers--copy" data-copy="${this.current_path.feature_name}" data-action="click->app--helpers--copy#copy">${this.current_path.feature_name}</span>
                                  <span class="mc-tooltiptext mc-tooltiptext-right">Clique para Copiar</span>
                                </span> <br>
                              </td>
                            <tr>
                            <tr>
                              <th colspan="1" class="f-065 align-middle px-0">
                                <strong>Nome</strong>
                              </th>
                              <td colspan="4" class="f-065 align-middle px-0 text-left">
                                <span class="mb-0 f-065 mc-tooltip grab">
                                  <span data-controller="app--helpers--copy" data-copy="${this.current_path.feature_humanize}" data-action="click->app--helpers--copy#copy">${this.current_path.feature_humanize}</span>
                                  <span class="mc-tooltiptext mc-tooltiptext-right">Clique para Copiar</span>
                                </span> <br>
                              </td>
                            <tr>
                            <tr>
                            </tr>
                              <th colspan="1" class="f-065 align-middle px-0">
                                <strong>URL</strong>
                              </th>
                              <td colspan="4" class="f-065 align-middle px-0 text-left">
                                <span class="mb-0 f-065 mc-tooltip grab">
                                  <span data-controller="app--helpers--copy" data-copy="${this.current_path.path}" data-action="click->app--helpers--copy#copy">/${this.current_path.path}</span>
                                  <span class="mc-tooltiptext mc-tooltiptext-right">Clique para Copiar</span>
                                </span> <br>
                              </td>
                            </tr>
                            </tr>
                              <th colspan="1" class="f-065 align-middle px-0">
                                <strong>Tipo de Conta</strong>
                              </th>
                              <td colspan="4" class="f-065 align-middle px-0 text-left">
                                ${this.current_path.account_kind_pretty}
                              </td>
                            </tr>
                            
                            <tr>
                              ${spaceRow}
                            </tr>

                            
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("users--works--permissions--paths--dashboard").viewTarget.innerHTML = html)
    }).then(() => {
      controller.previewCardTarget.style.height = ($(window).height() * 0.6) + "px"
      controller.previewTitleTarget.innerText = `URL /${controller.current_path.path}`
      controller.getControllerByIdentifier("app--helpers--elements").tooltip()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    this.connect()
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  kindTranslate(kind) {
    if (kind == `team`) {
      return `Time`
    } else if (kind == `doctor`) {
      return `Médico`
    } else if (kind == `helper`) {
      return `Assistente`
    } else if (kind == `patient`) {
      return `Paciente`
    } else if (kind == `taker`) {
      return `Tomador`
    } else if (kind == `admin`) {
      return `Administrador`
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
